<script>
export default {};
</script>

<template>
   <div class="error">
      <div class="error__code">{{ $route.query.error_code }}</div>
      <h1>{{ $t($route.query.error_title) }}</h1>
      <p class="error__message">
         {{ $t($route.query.error_message) }}
      </p>
   </div>
</template>

<style scoped lang="scss">
.error {
   padding: 0 48px;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: flex-start;
   overflow: auto;

   h1 {
      margin: unset;
      margin: 12px 0 8px 0;
   }
   p {
      margin: unset;
   }
   button {
      margin: 12px 0;
   }
}
.error__code {
   color: var(--nxt-main-hover);
   font-size: 100px;
   font-weight: 600;
   width: 100%;
   line-height: 100px;
   display: flex;
   align-items: center;
}
</style>

